import React, { useEffect, useState } from 'react';
import './css/InventoryPage.css';
import { useAuth } from '../context/AuthContext';

const passwordPolicyMessage = 'Password must include a capital letter, a number, and a special character.';

const validatePasswordPolicy = (value) => {
  if (!/[A-Z]/.test(value)) return passwordPolicyMessage;
  if (!/[0-9]/.test(value)) return passwordPolicyMessage;
  if (!/[^A-Za-z0-9]/.test(value)) return passwordPolicyMessage;
  return '';
};

const LoginPage = () => {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState('');
  const [passwordStatus, setPasswordStatus] = useState('');
  const [savingPassword, setSavingPassword] = useState(false);
  const { user, login, changePassword } = useAuth();

  useEffect(() => {
    document.title = "Login - Services Irene's Wigs.com";
  }, []);

  const handleLogin = async (event) => {
    event.preventDefault();
    setStatus('');
    setPasswordStatus('');

    try {
      const loggedInUser = await login(name, password);
      if (loggedInUser?.mustChangePassword) {
        setPassword('');
        return;
      }
      setStatus('Login successful');
    } catch (err) {
      setStatus(err.message);
    }
  };

  const handleChangePassword = async (event) => {
    event.preventDefault();
    setPasswordStatus('');

    if (newPassword !== confirmPassword) {
      setPasswordStatus('Passwords do not match.');
      return;
    }
    if (currentPassword === newPassword) {
      setPasswordStatus('New password cannot be the same as the current password.');
      return;
    }

    const policyError = validatePasswordPolicy(newPassword);
    if (policyError) {
      setPasswordStatus(policyError);
      return;
    }

    setSavingPassword(true);
    try {
      await changePassword(currentPassword, newPassword);
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setPasswordStatus('Password changed successfully.');
    } catch (err) {
      setPasswordStatus(err.message);
    } finally {
      setSavingPassword(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <h2>Login</h2>
        <form onSubmit={handleLogin} className="login-form">
          <input
            type="text"
            placeholder="Username"
            value={name}
            onChange={(event) => setName(event.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
          <button type="submit">Login</button>
          {status && <p className="status-message">{status}</p>}
        </form>
      </div>

      {user?.mustChangePassword && (
        <div className="password-reset-overlay" role="presentation">
          <form className="password-reset-modal" onSubmit={handleChangePassword}>
            <h3>Change Password</h3>
            <p>Your password must be changed before you can continue.</p>
            <label>
              Current Password
              <input
                type="password"
                value={currentPassword}
                onChange={(event) => setCurrentPassword(event.target.value)}
                autoComplete="current-password"
                required
              />
            </label>
            <label>
              New Password
              <input
                type="password"
                value={newPassword}
                onChange={(event) => setNewPassword(event.target.value)}
                autoComplete="new-password"
                required
              />
            </label>
            <label>
              Confirm Password
              <input
                type="password"
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
                autoComplete="new-password"
                required
              />
            </label>
            <div className="password-reset-rules">{passwordPolicyMessage}</div>
            {passwordStatus && <p className="status-message">{passwordStatus}</p>}
            <button type="submit" disabled={savingPassword}>
              {savingPassword ? 'Saving...' : 'Change Password'}
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default LoginPage;
